import { ButtonTheme, ButtonType } from '@ui-components/PlayButton';
import PlayText, { SIZE } from '@ui-components/typography/PlayText';
import { UserSurveyFragment } from 'app/graphql/__generated__/types/contento';
import { useRouter } from 'next/router';
import React, { useState } from 'react';
import { Task } from '../models';
import {
    Button,
    ButtonWrapper,
    Byline,
    CustomRadio,
    Form,
    Heading,
    Input,
    InputWrapper,
    Label,
    Legend,
    LegendWrapper,
    StyledRange,
} from '../UsabilityTest.styles';

type Props = {
    onClick: (value: number) => void;
    onCloseSurvey: (value: string) => void;
    task: Task;
    survey: UserSurveyFragment;
};

const Expected = ({ onClick, onCloseSurvey, survey, task }: Props) => {
    const [difficulty, setDifficulty] = useState(null);
    const router = useRouter();

    const onValueChange = (value: number) => {
        setDifficulty(value);
    };

    const getInputs = () => {
        const inputs = [];

        for (let i = 1; i <= 7; i++) {
            inputs.push(
                <Label key={`expected-input-${i}`}>
                    {i}
                    <Input
                        checked={difficulty === i}
                        type="radio"
                        value={i}
                        onChange={() => onValueChange(i)}
                    />
                    <CustomRadio />
                </Label>
            );
        }

        return inputs;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onClick(difficulty);
        setDifficulty(null);
        router.push('/');
    };

    return (
        <>
            <Byline size={SIZE.SMALL}>Uppgift</Byline>

            <Heading>{task.heading}</Heading>
            <PlayText>Hur lätt eller svårt förväntar du dig det är att utföra uppgiften?</PlayText>
            <Form onSubmit={handleSubmit}>
                <InputWrapper>{getInputs()}</InputWrapper>

                <StyledRange />
                <LegendWrapper>
                    <Legend>Mycket svårt</Legend>
                    <Legend>Mycket lätt</Legend>
                </LegendWrapper>

                <ButtonWrapper>
                    <Button
                        buttonType={ButtonType.BUTTON}
                        theme={ButtonTheme.DEFAULT}
                        type="button"
                        onClick={() => {
                            onCloseSurvey(survey.id);
                        }}
                        cancel
                    >
                        Avbryt
                    </Button>
                    <Button
                        isDisabled={difficulty === null}
                        buttonType={ButtonType.BUTTON}
                        theme={ButtonTheme.WHITE}
                        type="submit"
                    >
                        Starta uppgiften
                    </Button>
                </ButtonWrapper>
            </Form>
        </>
    );
};

export default Expected;
